//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class ContactUs extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, t } = this.props;
    const componentClasses = classNames(styles.ContactUs, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        <h1 tabIndex={'0'} className={styles.Title}>
          {t('landing_ContactUs')}
        </h1>
        <div className={styles.ContactInfo}>
          <h2 className={styles.ContactInfoItem}>{t('landing_Phone')}</h2>
          <h2 className={styles.ContactInfoItem}>{t('landing_Email')}</h2>
          <h2 className={styles.ContactInfoItem}>{t('landing_Time')}</h2>
        </div>
        <a href="/support" className={styles.SupportBtn}>
          {t('landing_Support')}
        </a>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(ContactUs);
